import { SetupCall } from '@driscollsinc/driscolls-display-rules';
import { LOOKUP_FIELDS } from '../constants';
import { lookupSetupFields } from './CommonSetupFields';

function configureSetupCall() {
    SetupCall(
        LOOKUP_FIELDS.GrowerCategoryLookUp,
        [...lookupSetupFields],
        {}, //options
        (data) => {
            console.log('GrowerCategoryLookUp REDUCER-- ', data);
        }
    );
}

const GrowerCategoryLookUp = {
    configureSetupCall
};

export default GrowerCategoryLookUp;
